(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const countdownElements = document.querySelectorAll('.countdown-timer');

    countdownElements.forEach((element) => {
      const targetDate = new Date(element.dataset.targetDate.replace(/-/g, '/')).getTime();
      const endText = element.dataset.endText;
      const daysUnit = element.dataset.daysUnit;
      const prefix = element.dataset.prefix;
      const suffix = element.dataset.suffix;

      const updateTimer = () => {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
          element.innerHTML = endText;
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        element.querySelector('.days').textContent = String(days).padStart(2, '0');
        element.querySelector('.hours').textContent = String(hours).padStart(2, '0');
        element.querySelector('.minutes').textContent = String(minutes).padStart(2, '0');
        element.querySelector('.seconds').textContent = String(seconds).padStart(2, '0');
      };

      updateTimer();
      setInterval(updateTimer, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_module"] && !window.DesignMode) return;
  try {
    
  function toggleFAQ(item) {
    const content = item.querySelector('.zd-faq-content');
    const arrow = item.querySelector('.zd-icon');
    
    if (content.classList.contains('zd-open')) {
      content.classList.remove('zd-open');
      arrow.innerHTML = '<svg t="1740554975528" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2433" width="200" height="200"><path d="M604.7488 513.659733l-196.292267 196.9024a36.872533 36.872533 0 0 0-1.041066 50.978134 33.8048 33.8048 0 0 0 48.810666 1.019733l218.2144-218.478933c16.648533-16.669867 16.64-43.677867-0.0256-60.330667L455.466667 264.917333a33.493333 33.493333 0 0 0-48.349867 1.041067 36.5312 36.5312 0 0 0 1.041067 50.496l196.590933 197.201067z" fill="#333333" p-id="2434"></path></svg>'; 
    } else {
      content.classList.add('zd-open');
      arrow.innerHTML = '<svg t="1740555024782" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1589" width="200" height="200"><path d="M511.8592 602.282667l196.906667-196.296534a36.872533 36.872533 0 0 1 50.973866-1.041066 33.8048 33.8048 0 0 1 1.024 48.810666l-218.4832 218.2144c-16.6656 16.6528-43.677867 16.64-60.330666-0.0256L263.125333 452.996267a33.493333 33.493333 0 0 1 1.041067-48.3456 36.5312 36.5312 0 0 1 50.491733 1.041066l197.205334 196.586667z" fill="#333333" p-id="1590"></path></svg>'; 
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    const faqItems = document.querySelectorAll('.zd-faq-item');

    faqItems.forEach(item => {
      item.addEventListener('click', function() {
        toggleFAQ(this);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-highlights"] && !window.DesignMode) return;
  try {
    
  const $textLists = $(".P1_P4_sticky_wrapper .ScrollText .text-list"), 
        $units = $(".P1_P4_sticky_wrapper .units .unit"), 
        $specMessage = $(".P1_P4_sticky_wrapper .spec-message"), 
        $scrollNumbers = $(".P1_P4_sticky_wrapper .scroll-number"), 
        $comma = $(".P1_P4_sticky_wrapper .text-comma");
  var prevSpecID = 0;
  function setNumbers(nextSpec, specID) {
    var spec = window.specData[nextSpec], characters = spec.unit, numbers = spec.count.replace(/[a-zA-Z]+/g, "").trim(), numberCounter = numbers.toString().length;
    if(specID != prevSpecID) {
      $textLists.removeAttr("style")
      $comma.removeAttr("style")
      if (numberCounter > 3) {
        $comma.css({ width:"auto" })
      }
      $textLists.each(function(i) {
        if(numbers[i]) {
          var translateY = $textLists.find("li").height() * numbers[i];
          $(this).css("transform", "translateY(-" + translateY + "px)").css({ width:"auto" });
        }
      });
      $units.each(function(i) {
        var translateY = 0, unitText = $(this).data("unit");
        if (unitText == characters) {
          $(".P1_P4_sticky_wrapper .text-units").width($(this).find("span").width() + "px");
          translateY = $(this).height() * i;
          $(".P1_P4_sticky_wrapper .units").css("transform", "translateY(-" + translateY + "px)");
        }
      });
      if ($specMessage.html() !== spec.message) {
        $specMessage.html(spec.message);
        $('.text-animation-wrapper').get(0).style.setProperty("--spec-background-image", "url('"+spec.bgImage+"')");
        console.log()
      }
      prevSpecID = specID;
    }
  }

  function desktop(){
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    setNumbers("spec1", 1);

    gsap.set(".P1_P4_sticky_wrapper .card", { position: "sticky" });
    gsap.set(".P1_P4_sticky_wrapper .image-card", { scale: 0.8 });
    const textAnimationTimeline1 = gsap.timeline({
      scrollTrigger: {
        trigger: ".P1_P4_sticky_wrapper",
        start: "top top",
        end: "bottom bottom",
        scrub: 0.3
      }
    });
    textAnimationTimeline1.to(".P1_P4_sticky_wrapper .image-card", { scale: 1, opacity: 0, direction: 0.33 });
    textAnimationTimeline1.to(".P1_P4_sticky_wrapper .card-2", { direction: 0.33, onUpdate: function () { setNumbers("spec1", 1); }}, 0);
    textAnimationTimeline1.to(".P1_P4_sticky_wrapper .card-2", { direction: 0.33, onUpdate: function () { setNumbers("spec2", 2); }}, 1);
    textAnimationTimeline1.to(".P1_P4_sticky_wrapper .card-2", { direction: 0.33, onUpdate: function () { setNumbers("spec3", 3); }}, 2);
    textAnimationTimeline1.to(".P1_P4_sticky_wrapper .card-2", { direction: 0.33, onUpdate: function () { setNumbers("spec4", 4); }}, 3);
  }

  var w = window.innerWidth;
  var size = w > 1024 ? "big" : "small";
  if (size === "big") {
    desktop();
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-content-module"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const modules = document.querySelectorAll('.zd-tc-module');
  
  modules.forEach(module => {
    const tabButtons = module.querySelectorAll('.zd-tc-tab-button');
    const tabContents = module.querySelectorAll('.zd-tc-tab-text-content');
    const mediaItems = module.querySelectorAll('.zd-tc-media-item');
    
    if (!tabButtons.length || !tabContents.length) return;

    function switchTab(targetIndex) {
      // 暂停所有视频
      mediaItems.forEach(item => {
        const video = item.querySelector('video');
        if (video) {
          video.pause();
        }
      });

      // 更新状态
      tabButtons.forEach(tab => tab.classList.remove('zd-tc-active'));
      tabContents.forEach(content => content.classList.remove('zd-tc-active'));
      mediaItems.forEach(item => item.classList.remove('zd-tc-active'));
      
      tabButtons[targetIndex].classList.add('zd-tc-active');
      tabContents[targetIndex].classList.add('zd-tc-active');
      mediaItems[targetIndex].classList.add('zd-tc-active');
      
      // 播放新视频
      const newVideo = mediaItems[targetIndex].querySelector('video');
      if (newVideo) {
        newVideo.play();
      }
    }

    tabButtons.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        switchTab(index);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-image-module"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const modules = document.querySelectorAll('.zd-ti-tab-image-module');
  
  modules.forEach(module => {
    const tabDivs = module.querySelectorAll('.zd-ti-tab-button');
    const tabImages = module.querySelectorAll('.zd-ti-tab-image');
    
    if (!tabDivs.length || !tabImages.length) return;

    tabDivs.forEach(div => {
      div.addEventListener('click', () => {
        const targetIndex = div.getAttribute('data-tab-index');
        
        tabDivs.forEach(d => {
          d.classList.remove('zd-ti-active');
        });
        div.classList.add('zd-ti-active');
        
        tabImages.forEach(image => {
          const imageIndex = image.getAttribute('data-tab-index');
          if (imageIndex === targetIndex) {
            image.classList.add('zd-ti-active');
          } else {
            image.classList.remove('zd-ti-active');
          }
        });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
